var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.size]},[_c('font-awesome-icon',{staticClass:"mr-1",attrs:{"icon":"chalkboard-teacher"}}),_vm._v("\n    "+_vm._s(_vm.group.group_name)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }